module.exports = __webpack_public_path__ + "static/media/danger-icon.5af9f64b.svg";